import React, { useEffect, useState, useCallback } from "react";
import api from "../../api";
import { GraduationCap, Pause } from "lucide-react";

const TYPE_META = {
  aspettativa: { label: "Aspettativa non retribuita", cls: "bg-gray-200 text-gray-700", icon: Pause },
  permesso_studio: { label: "Permesso studio", cls: "bg-purple-100 text-purple-700", icon: GraduationCap },
};
const STATUS = {
  in_attesa: { label: "In attesa", cls: "bg-amber-100 text-amber-700" },
  approvata: { label: "Approvata", cls: "bg-green-100 text-green-700" },
  rifiutata: { label: "Rifiutata", cls: "bg-red-100 text-red-700" },
  annullata: { label: "Annullata", cls: "bg-gray-100 text-gray-500" },
};
const fmt = (iso) => (iso && iso.length >= 10 ? iso.slice(0, 10).split("-").reverse().join("/") : iso);

export const SpecialLeavesTab = () => {
  const [year, setYear] = useState(new Date().getFullYear());
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(() => {
    setLoading(true);
    api.get(`/reports/special-leaves?year=${year}`).then((r) => setItems(r.data.items || [])).catch(() => {}).finally(() => setLoading(false));
  }, [year]);
  useEffect(() => { load(); }, [load]);

  const years = [];
  const cy = new Date().getFullYear();
  for (let y = cy + 1; y >= cy - 4; y--) years.push(y);

  return (
    <div data-testid="special-leaves-tab">
      <div className="flex items-center gap-3 mb-4">
        <label className="text-[13px] font-semibold text-gray-600">Anno</label>
        <select value={year} onChange={(e) => setYear(Number(e.target.value))} data-testid="special-year" className="border border-gray-300 rounded-sm px-3 py-2 text-[14px] outline-none focus:border-[#16345c]">
          {years.map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>

      {loading ? (
        <div className="bg-white border border-gray-200 rounded-lg p-10 text-center text-gray-400">Caricamento...</div>
      ) : items.length === 0 ? (
        <div className="bg-white border border-gray-200 rounded-lg p-10 text-center text-gray-400 text-[13px]">Nessuna aspettativa o permesso studio nel {year}.</div>
      ) : (
        <div className="bg-white border border-gray-200 rounded-lg overflow-x-auto">
          <table className="w-full min-w-[720px]">
            <thead>
              <tr className="bg-[#16345c] text-white text-[12px] uppercase tracking-wide">
                <th className="text-left px-4 py-3 font-bold">Dipendente</th>
                <th className="text-left px-4 py-3 font-bold">Tipo</th>
                <th className="text-left px-4 py-3 font-bold">Periodo</th>
                <th className="text-right px-4 py-3 font-bold">Durata</th>
                <th className="text-left px-4 py-3 font-bold">Stato</th>
              </tr>
            </thead>
            <tbody>
              {items.map((it) => {
                const meta = TYPE_META[it.type] || { label: it.type, cls: "bg-gray-100 text-gray-600", icon: Pause };
                const Icon = meta.icon;
                return (
                  <tr key={it.id} className="border-b border-gray-100 last:border-0 hover:bg-gray-50 transition-colors">
                    <td className="px-4 py-3">
                      <div className="text-[14px] font-bold text-[#16345c]">{it.employee_name}</div>
                      <div className="text-[11px] text-gray-500">{it.matricola} · {it.dept}</div>
                    </td>
                    <td className="px-4 py-3">
                      <span className={`inline-flex items-center gap-1 text-[11px] font-bold px-2 py-0.5 rounded-full ${meta.cls}`}><Icon size={12} /> {meta.label}</span>
                    </td>
                    <td className="px-4 py-3 text-[13px] text-gray-600">{fmt(it.start_date)} → {fmt(it.end_date)}</td>
                    <td className="px-4 py-3 text-right text-[13px] font-semibold text-[#16345c]">
                      {it.type === "permesso_studio" ? `${it.hours ?? 0} ore` : `${it.days_count ?? 0} gg`}
                    </td>
                    <td className="px-4 py-3"><span className={`text-[11px] font-bold px-2 py-0.5 rounded-full ${STATUS[it.status]?.cls}`}>{STATUS[it.status]?.label || it.status}</span></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
